/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectResource } from './projectResource';


/**
 * Program resource
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProgramResource { 
    /**
     * Unique identifier for Project
     */
    readonly projectIdentifier?: string;
    /**
     * Project name
     */
    readonly projectName?: string;
    /**
     * Resources for Projects
     */
    readonly projectResources?: Array<ProjectResource>;

    constructor(item?: Partial<ProgramResource>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            projectIdentifier: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.projectIdentifier : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            projectName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.projectName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            projectResources: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.projectResources : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProgramResource.isValid,
        };
    }

    static isValid(obj: ProgramResource): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProgramResource.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.projectIdentifier.isValid(item);
            result = result && validationObject.projectName.isValid(item);
            result = result && validationObject.projectResources.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

